/*
 * My MAGIC rewards page - links (snippets/my-magic-assets.liquid)
 * - Logged-out visitors who log in or sign up from this page come back to it. The store uses new customer
 *   accounts, where /account/login and /account/register drop any return path (also Yotpo's checkout_url), so
 *   every account link on the page (theme header, section buttons, Yotpo's "Join now" / "Sign in") is sent to
 *   /customer_authentication/login with return_to. New customer accounts have one page for both.
 *   Links are rewritten when clicked; Yotpo's buttons, which set window.location, are caught with the
 *   Navigation API.
 * - Logged-in customers: the Yotpo member summary's "Redeem points" scrolls to the section set in the hero
 *   (data-mm-redeem-link), instead of Yotpo's own scroll, which misses the widget inside our layout.
 */
(function () {
  'use strict';

  if (window.myMagicLinks) return;
  window.myMagicLinks = true;

  const script = document.currentScript;
  const loggedIn = script && script.dataset.loggedIn === 'true';

  // /account, /account/login, /account/register and Shopify's own login routes, with an optional language prefix
  const ACCOUNT_PAGE = /^(\/[a-z]{2}(-[a-z]{2})?)?\/(account(\/login|\/register)?|customer_authentication\/(login|redirect))\/?$/i;

  const loginUrl = () => {
    const params = new URLSearchParams({ return_to: location.pathname + location.search });
    if (document.documentElement.lang) params.set('locale', document.documentElement.lang);
    return `/customer_authentication/login?${params}`;
  };

  const needsReturn = (href) => {
    try {
      const url = new URL(href, location.href);
      return url.origin === location.origin && ACCOUNT_PAGE.test(url.pathname) && !url.searchParams.has('return_to');
    } catch (error) {
      return false;
    }
  };

  if (!loggedIn) {
    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('a[href]');
        if (link && needsReturn(link.href)) link.href = loginUrl();
      },
      true
    );

    if (window.navigation) {
      window.navigation.addEventListener('navigate', (event) => {
        if (!event.cancelable || event.hashChange || event.downloadRequest !== null) return;
        if (!needsReturn(event.destination.url)) return;
        event.preventDefault();
        location.href = loginUrl();
      });
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-mm-redeem-link] .yotpo-primary-button');
      if (!button) return;

      const link = button.closest('[data-mm-redeem-link]').dataset.mmRedeemLink;
      const target = link.startsWith('#') ? document.getElementById(link.slice(1)) : null;
      event.preventDefault();
      event.stopPropagation();
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (!link.startsWith('#')) {
        location.href = link;
      }
    },
    true
  );
})();
